<template>
  <div v-title :data-title="'卓考网校|' + courseName + '|知识点'">
    <header class="g-header-container">
      <c-header :title="courseName" />
    </header>
    <main class="g-view-container">
      <div class="chapter-list">
        <div
          class="chapter"
          v-for="item in list"
          :key="item.chapterNo"
          @click="onLearn(item.chapterNo, item.name, item.total)"
        >
          <p class="chapter__top">
            <span class="iconfont iconphysical"></span>
            <span class="chapter-title">
              {{ `${item.chapterNoZh} ${item.name}` }}
            </span>
          </p>
          <p class="chapter__down">
            <span class="chapter-num">
              {{ item.total ? `共${item.total}个` : "更新中" }}
            </span>
            <span class="btn-learn">开始学习</span>
          </p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import Course from 'models/course';
  import CHeader from 'components/header';

  export default {
    name: 'knowList',
    components: {
      CHeader,
    },
    data() {
      return {
        courseId: this.$route.params.courseId || 3,
        list: [],
      };
    },
    created() {
      this.courseName = Course.getCourseName(this.courseId);
      this.getKnow();
    },
    methods: {
      getKnow() {
        this.showLoading();
        this.axios
          .get(
            `https://cbt.tibaitong.com/courseChapter/getChapter?courseId=${this.courseId}`,
          )
          .then((res) => {
            this.hideLoading();
            if (res.data.code === 200) {
              this.list = res.data.data.chapterVos;
            }
          });
      },
      onLearn(chapterNo, chapterName, total) {
        if (!total || total <= 0) {
          this.$toast('本章节暂时没有知识点哟');
          return;
        }
        this.$router.push({
          name: 'knowDetail',
          query: {
            courseId: this.courseId,
            chapterNo,
            chapterName,
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.chapter-list {
  margin: 15px;
  padding: 10px;
  background-color: #fff;
  border-radius: 10px;
}

.chapter {
  position: relative;
  padding: 5px 0;
}

.chapter + .chapter {
  border-top: 0.5px solid #ccc;
}

.chapter p {
  display: flex;
  align-items: center;
  padding-left: 26px;
  height: 32px;
}

.chapter__top .iconfont {
  position: absolute;
  left: 0;
  top: 12px;
  font-size: 20px;
  color: $theme-color;
}

.chapter-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.chapter__down {
  justify-content: space-between;
}

.chapter-num {
  font-size: 12px;
  color: #666;
}

.btn-learn {
  padding: 3px 5px;
  font-size: 10px;
  color: #fff;
  background-color: $theme-color;
  border-radius: 2px;
}
</style>
